import { type DocumentPathFolder } from '~/components/Modals/MultipleLocationsModal/MultipleLocationsModal';
import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

type Request = {
  handlerIds: PilotId[];
};

type ServerResponse = {
  data?: Array<{
    id: number;
    path?: DocumentPathFolder[];
  }>;
};

type HandlerFolderPath = {
  id: number;
  path: DocumentPathFolder[];
};

export const getDocumentHandlerPaths = async ({
  handlerIds,
}: Request): Promise<HandlerFolderPath[]> => {
  const serverResponse: ServerResponse = await pilot.get('path/documents/', {
    params: { 'ids[]': handlerIds },
  });

  return mapResponse(serverResponse);
};

const mapResponse = (serverResponse: ServerResponse): HandlerFolderPath[] =>
  (serverResponse?.data ?? []).map(({ id, path }) => ({
    id,
    path: path ?? [],
  }));
